<template>
	<AIInfoCard v-if="!block.data.audio"></AIInfoCard>

	<div v-else>
		<block-audio-viewer :value="block" />
	</div>
</template>
<script>
import AIInfoCard from '../_components/placeholders/AIInfoCard.vue';
import BlockAudioViewer from './BlockAudioViewer.vue';

export default {
	name: 'BlockAIAvailable',
	props: ['block'],
	components: { BlockAudioViewer, AIInfoCard }
};
</script>
<style scoped>
.ai-text {
	height: auto;
}
</style>
